/* eslint-disable */
import saveStoreDraft from "../../utils/saveStoreDraft";
import useStoreFormDraft from "../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { doc } from "firebase/firestore";
import { db } from "../../firebase";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { applyStoreDraft } from "../../redux/store/store";
import {
  Check,
  RefreshCw,
  Info,
  Truck,
  Package,
  Clock,
  MapPin,
  X,
  Eye,
  EyeOff,
} from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ActivationEcomDeliveryV2() {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.StoreReducer);

  const isConnected =
    store.ecomdeliveryv2_key !== null &&
    store.ecomdeliveryv2_key !== "" &&
    store.ecomdeliveryv2_key !== false &&
    store.ecomdeliveryv2_key !== undefined &&
    store.ecomdeliveryv2_token !== null &&
    store.ecomdeliveryv2_token !== "" &&
    store.ecomdeliveryv2_token !== false &&
    store.ecomdeliveryv2_token !== undefined;

  const [showKey, setShowKey] = useState(false);
  const [showToken, setShowToken] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSideBar, setShowSideBar] = useState(true);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [data, setData] = useStoreFormDraft(store);

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!data) return;

    try {
      const headers = {
        "X-API-Key": `${data.ecomdeliveryv2_key || ""}`,
        "X-API-Token": `${data.ecomdeliveryv2_token || ""}`,
      };

      const response = await axios.get("https://ecom-dz.com/api_v2/test", {
        headers,
      });

      if (response.status === 200) {
        await saveStoreDraft(doc(db, "store", data.id), store, data);
        dispatch(applyStoreDraft(store, data));
        setData(data);

        Swal.fire({
          icon: "success",
          title: t("activationCompanies.alerts.activationSuccess.title"),
          text: response.data?.nom_fournisseur || "",
          confirmButtonText: t("activationCompanies.alerts.confirmButton"),
          confirmButtonColor: "rgb(141, 93, 167)",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: t("activationCompanies.alerts.activationError.title"),
          text: `${t("activationCompanies.alerts.activationError.text")} `,
          confirmButtonText: t("activationCompanies.alerts.confirmButton"),
        });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: t("activationCompanies.alerts.activationError.title"),
        text:
          error.response?.data?.error?.message ||
          t("activationCompanies.alerts.activationError.text"),
        confirmButtonText: t("activationCompanies.alerts.confirmButton"),
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDeactivate = async () => {
    const result = await Swal.fire({
      icon: "warning",
      title: t("activationCompanies.alerts.deactivateConfirm.title"),
      text: t("activationCompanies.alerts.deactivateConfirm.text"),
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#aaa",
      confirmButtonText: t(
        "activationCompanies.alerts.deactivateConfirm.confirmText",
      ),
      cancelButtonText: t(
        "activationCompanies.alerts.deactivateConfirm.cancelText",
      ),
      backdrop: `rgba(0,0,0,0.7)`,
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });

    if (result.isConfirmed) {
      try {
        const updatedData = { ...data };
        delete updatedData.ecomdeliveryv2_key;
        delete updatedData.ecomdeliveryv2_token;

        await saveStoreDraft(doc(db, "store", data.id), store, updatedData);
        dispatch(applyStoreDraft(store, updatedData));
        setData(updatedData);

        await Swal.fire({
          icon: "success",
          title: t("activationCompanies.alerts.deactivateSuccess.title"),
          text: t("activationCompanies.alerts.deactivateSuccess.text"),
          confirmButtonText: t("activationCompanies.alerts.confirmButton"),
          confirmButtonColor: "rgb(141, 93, 167)",
          customClass: {
            popup: "swal-popup-on-top",
          },
        });
      } catch (error) {
        console.error("Error during deactivation:", error);
        await Swal.fire({
          icon: "error",
          title: t("activationCompanies.alerts.deactivateError.title"),
          text: t("activationCompanies.alerts.deactivateError.text"),
          confirmButtonText: t("activationCompanies.alerts.confirmButton"),
          confirmButtonColor: "rgb(141, 93, 167)",
        });
      }
    }
  };

  return (
    <div className="min-h-[400px] h-fit p-6 dark:!bg-[#181819] dark:!text-gray-200">
      <h3 className="text-lg font-semibold text-[#9e68ba] mb-3">
        {t("activationCompanies.ecomdeliveryv2.title")}
      </h3>
      <Form onSubmit={handleSubmit}>
        <div className="mb-4">
          <p className="font-medium text-gray-700 mb-3 dark:!text-gray-300">
            {t("activationCompanies.ecomdeliveryv2.accountIdLabel")}
          </p>
          <Form.Group className="mb-3">
            <div className="relative mb-3">
              <Form.Control
                type={showKey ? "text" : "password"}
                placeholder={t(
                  "activationCompanies.ecomdeliveryv2.accountIdPlaceholder2",
                )}
                value={data.ecomdeliveryv2_key || ""}
                onChange={(e) =>
                  setData({ ...data, ecomdeliveryv2_key: e.target.value })
                }
                className="mb-3 border-gray-300 rounded-lg p-2 pr-12
                     placeholder-gray-400 dark:!placeholder-gray-500
                     dark:!border-[#3c3a3d] dark:!bg-[#181919] dark:!text-gray-200
                     focus:ring-2 focus:ring-[#9e68ba] mr-[32px]"
                style={{
                  direction: i18n.dir(),
                  textAlign: i18n.dir() === "rtl" ? "right" : "left",
                  width: "94%",
                }}
              />
              <button
                type="button"
                onClick={() => setShowKey(!showKey)}
                className="absolute inset-y-0 right-0 flex items-center pr-3
                  text-gray-500 hover:text-[#9e68ba] dark:text-gray-400"
              >
                {showKey ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>

            <div className="relative mb-3">
              <Form.Control
                type={showToken ? "text" : "password"}
                placeholder={t(
                  "activationCompanies.ecomdeliveryv2.accountIdPlaceholder1",
                )}
                value={data.ecomdeliveryv2_token || ""}
                onChange={(e) =>
                  setData({ ...data, ecomdeliveryv2_token: e.target.value })
                }
                className="mb-3 border-gray-300 rounded-lg p-2 pr-12
                     placeholder-gray-400 dark:!placeholder-gray-500
                     dark:!border-[#3c3a3d] dark:!bg-[#181919] dark:!text-gray-200
                     focus:ring-2 focus:ring-[#9e68ba] mr-[32px]"
                style={{
                  direction: i18n.dir(),
                  textAlign: i18n.dir() === "rtl" ? "right" : "left",
                  width: "94%",
                }}
              />
              <button
                type="button"
                onClick={() => setShowToken(!showToken)}
                className="absolute inset-y-0 right-0 flex items-center pr-3
                  text-gray-500 hover:text-[#9e68ba] dark:text-gray-400"
              >
                {showToken ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>

            <Form.Text className="text-muted dark:!text-gray-400">
              {t("activationCompanies.ecomdeliveryv2.accountIdHint")}
            </Form.Text>
          </Form.Group>
        </div>

        {/* Tips Section */}
        <div
          className="bg-[#fcf6ff] p-4 rounded-lg border border-[#fbf4ff] mb-4
                    dark:!bg-[#181919] dark:!border-[#3c3a3d]"
        >
          <h4 className="font-medium text-xl text-[#9e68ba] mb-2 d-flex align-items-center">
            <Info size={18} className="ml-2" />
            {t("activationCompanies.ecomdeliveryv2.tipsTitle")}
          </h4>
          <ul className="text-sm text-gray-700 space-y-2 mr-5 list-disc dark:!text-gray-300">
            <li className="d-flex align-items-start mb-2">
              <Truck
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>
                {t("activationCompanies.ecomdeliveryv2.tips.tracking")}
              </span>
            </li>
            <li className="d-flex align-items-start mb-2">
              <Package
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>
                {t("activationCompanies.ecomdeliveryv2.tips.packaging")}
              </span>
            </li>
            <li className="d-flex align-items-start mb-2">
              <Clock
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>{t("activationCompanies.ecomdeliveryv2.tips.timing")}</span>
            </li>
            <li className="d-flex align-items-start">
              <MapPin
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>
                {t("activationCompanies.ecomdeliveryv2.tips.coverage")}
              </span>
            </li>
          </ul>
        </div>

        <div className="d-flex justify-content-between mt-4">
          {!isConnected ? (
            <Button
              type="submit"
              disabled={loading}
              className="d-flex align-items-center justify-content-center"
              style={{
                backgroundColor: "rgb(141, 93, 167)",
                borderColor: "rgb(141, 93, 167)",
                opacity: loading ? 0.7 : 1,
                cursor: loading ? "not-allowed" : "pointer",
                transition: "all 0.2s ease",
                borderRadius: "0.5rem",
                padding: "0.5rem 1.5rem",
                minWidth: "150px",
              }}
            >
              {loading ? (
                <>
                  <RefreshCw className="animate-spin ml-2" size={18} />
                  {t("activationCompanies.ecomdeliveryv2.activating")}
                </>
              ) : (
                <>
                  <Check className="ml-2" size={18} />
                  {t("activationCompanies.ecomdeliveryv2.activate")}
                </>
              )}
            </Button>
          ) : (
            <Button
              variant="danger"
              className="d-flex align-items-center justify-content-center"
              onClick={handleDeactivate}
              style={{
                borderRadius: "0.5rem",
                padding: "0.5rem 1.5rem",
                minWidth: "150px",
              }}
            >
              <X className="ml-2" size={18} />
              {t("activationCompanies.ecomdeliveryv2.deactivate")}
            </Button>
          )}
        </div>
      </Form>
    </div>
  );
}
